function OrganizationCtrl(OrganizationService, $state, $stateParams, AppSettings, $rootScope, CommonService,AdminService,$scope,toaster,ConnectionService) {
  'ngInject';
  // ViewModel
  const vm = this;
  vm.organizations = [];
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.name = !$stateParams.name ? '' : $stateParams.name;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.loading = false;
  vm.addUserForm = {};


  vm.init = function() {
    //to hide the organization name
    $rootScope.organizationNameView = false;
    vm.url = `/organizations.json?page=${vm.pageNumber}&size=${vm.size}&by_organization_name=${vm.name}&sort=${vm.sortBy}`;
    vm.loading = true;
    OrganizationService.listOrganization(vm.url, function(response) {
      vm.loading = false;
      if(response.status == 200) {
        vm.organizationResponse = response.data;
        vm.currentPage = !vm.organizationResponse.pagination ? 1 : vm.organizationResponse.pagination.current_page;
        vm.totalPages = !vm.organizationResponse.pagination ? 1 : vm.organizationResponse.pagination.total_pages;
        vm.organizations = response.data.organizations;
      }
    });
    };

  vm.search = function (name) {
    $state.go('user.organizations.list', {name: name});
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.organizations.list', {sortBy: param});
  };

  vm.paginate = function (param) {
    vm.url = vm.organizationResponse.links[param];
    if(vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organizations.list', {pageNumber: vm.pageNumber, size: vm.size});
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.organizationResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.organizations.list', {pageNumber: vm.pageNumber, size: vm.size})
  };

  vm.cancelButton=  function(ff){
    ff.$cancel();
  };

  vm.deleteOrganization = function(organization_id){
    swal({
      title: "Are you sure you want to delete this organization?",
      text: "All the information related with this organization will be deleted.",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willDelete => {
      if (willDelete) {
        ConnectionService.delete(organization_id, function (response) {
          if(response.status = '204') {
            vm.init();
          }
        });
      }});
  };

  vm.userList = function (orgId) {
    $state.go('user.organizations.userList', {orgId: orgId}, {inherit: false});
  };
  }

export default {
  name: 'OrganizationCtrl',
  fn: OrganizationCtrl
};
